<template>
  <div class="second-container">
    <AdminLeft/>
    <div class="column-con">
      <AdminTop/>
      <el-row style="width: 100%">
        <el-col :span="24" style="text-align: start;vertical-align: center">
          <el-radio-group v-model="queryData.type" size="large" style="margin: 0 20px;" @change="_radioChange">
            <el-radio :label="undefined">全部</el-radio>
          </el-radio-group>
          <el-cascader
              :options="options"
              :props="props"
              placeholder="请选择类别"
              @change="_selectChange"
              style="width: 300px;margin-left: 20px;"
          />

          <el-input
              v-model="queryData.search"
              placeholder="请输入要查找的标题"
              class="input"
          />
          <el-button type="primary" round @click="_getList">搜索</el-button>

          <el-button type="success" round @click="_handleToDetail(undefined)" style="margin-left: 20px;">新建</el-button>
        </el-col>
      </el-row>
      <el-table :data="listData" stripe style="width: 100%" v-loading="loading">
        <el-table-column prop="ID" label="ID" width="180"/>
        <el-table-column prop="post_title" label="标题" width="500"/>
        <el-table-column prop="post_date" label="发布日期"/>

<!--        <el-table-column prop="isShowHomePage" label="是否在首页显示">-->
<!--          <template v-slot="scope">-->
<!--            <el-switch-->
<!--                v-model="scope.row.isShowHomePage"-->
<!--                size="large"-->
<!--                active-text="是"-->
<!--                inactive-text="否"-->
<!--                :active-value="1"-->
<!--                :inactive-value="0"-->
<!--                @change="_switchChangeHomePage(scope.row)"-->
<!--            />-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column fixed="right" label="操作" width="300">
          <template v-slot="scope">
            <el-button round type="primary" @click="_handleToDetail(scope.row.ID)">查看</el-button>
            <el-button @click="_handleToDetailWeb(scope.row.ID)" round type="success">在网站中查看</el-button>
            <el-button round type="danger" @click="_delete(scope.row.ID)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="queryData.total" :page-size="15"
                     style="margin-top: 30px;"
                     @current-change="_pageChange"/>
    </div>
  </div>
</template>

<script>

import AdminLeft from "@/components/AdminLeft";
import AdminTop from "@/components/AdminTop";
import http from "@/util/http";
import {ElMessage, ElMessageBox} from "element-plus";


export default {
  name: "AdminArticle",
  components: {
    AdminLeft,
    AdminTop
  },
  data() {
    return {

      listData: [],
      queryData: {
        page: 1,
        total: 1,
        search: undefined,
        parent: undefined,
        type: undefined,
        child: undefined
      },
      loading: false,
      props: {
        expandTrigger: 'hover',
      },
      options: [
        {
          value: undefined,
          label: '全部',
          children: []
        },
        {
          value: 1,
          label: '时事新闻',
          children: []
        },
        {
          value: 2,
          label: '行业资讯',
          children: [],
        },
        {
          value: 3,
          label: '高新技术',
          children: [],
        },
        {
          value: 4,
          label: '国内资讯',
          children: []
        },
        {
          value: 5,
          label: '全球资讯',
          children: []
        },
        {
          value: 6,
          label: '互联网+新闻',
          children: []
        },
        {
          value: 7,
          label: '行业活动',
          children: []
        }
      ]
    }
  },
  mounted() {
    this._getList()
  },
  methods: {
    _switchChangeHomePage(e) {
      const isShowHomePage = e.isShowHomePage
      http.post('setHomePageArticle', {
        id: e.ID,
        type: isShowHomePage
      })
          .then((res) => {
            if (res.data.status === 0) {
              ElMessage.success(res.data.content)
            } else {
              ElMessage.error(res.data.content)
              for (let i = 0; i < this.listData.length; i++) {
                if (this.listData[i].ID === e.ID) {
                  this.listData[i].isShowHomePage = isShowHomePage === 0 ? 1 : 0
                  break
                }
              }
            }
          })
    },
    _switchChangeBottomPage(e) {
      const isShowHomeBottom = e.isShowHomeBottom
      http.post('setBottomPageArticle', {
        id: e.ID,
        type: isShowHomeBottom
      })
          .then((res) => {
            if (res.data.status === 0) {
              ElMessage.success(res.data.content)
            } else {
              ElMessage.error(res.data.content)
              for (let i = 0; i < this.listData.length; i++) {
                if (this.listData[i].ID === e.ID) {
                  this.listData[i].isShowHomeBottom = isShowHomeBottom === 0 ? 1 : 0
                  break
                }
              }
            }
          })
    },
    _pageChange(e) {
      this.queryData.page = e
      this._getList()
    },
    _radioChange() {
      this.queryData.page = 1
      this._getList()
    },
    _getList() {
      this.loading = true
      http.get('articleListAdmin', {
        page: this.queryData.page,
        search: this.queryData.search,
        parent: this.queryData.parent,
        type: this.queryData.type,
        child: this.queryData.child
      })
          .then((res) => {
            this.loading = false
            if (res.data.status !== 0) {
              ElMessage.warning(res.data.content)
              return
            }
            // const dataList = res.data.data.list
            // for (let i = 0; i < dataList.length; i++) {
            //   dataList[i].isShowHomePage = dataList[i].isShowHomePage === 0 ? '否' : '是'
            //   dataList[i].isShowHomeBottom = dataList[i].isShowHomeBottom === 0 ? '否' : '是'
            // }
            this.listData = res.data.data.list
            this.queryData.total = res.data.data.total
          })
    },
    _selectChange(e) {
      if (e.length >= 2) {
        this.queryData.parent = e[0]
        this.queryData.child = e[1]
      } else {
        this.queryData.parent = e[0]
        this.queryData.child = undefined
      }
      this.queryData.page = 1
      this._getList()
    },
    _handleToDetail(e) {
      let routeData = this.$router.resolve({
        path: "/DetailPageAdmin",
        query: {
          p: e
        }
      })

      window.open(routeData.href, '_blank')
    },
    _handleToDetailWeb(e) {
      let routeData = this.$router.resolve({
        path: "/detail",
        query: {
          id: e
        }
      })

      window.open(routeData.href, '_blank')
    },
    _delete(e) {
      ElMessageBox.confirm(
          '是否删除？',
          '确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      )
          .then(() => {
            console.log("e" + e)
            http.post('deleteArticle', {
              id: e
            })
                .then((res) => {
                  if (res.data.status === 0) {
                    ElMessage.success(res.data.content)
                    for (let i = 0; i < this.listData.length; i++) {
                      if (this.listData[i].ID === parseInt(e)) {
                        this.listData.splice(i, 1)
                        break
                      }
                    }
                  } else {
                    ElMessage.error(res.data.content)
                    if (res.data.status === 201) {
                      this.$router.push({
                        path: '/AdminLogin'
                      })
                    }
                  }
                })
          })
          .catch(() => {

          })
    }
  }
}
</script>

<style scoped>
.column-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.input {
  width: 500px;
  margin: 20px;
}
</style>